import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { buttonClass } from './ui/Button';

// The prefilled form for one `missing_credential` — `fix_url`. Presenter.
//
// A `null` IS AN ANSWER, NEVER AN ERROR. The port mints a link only for a row
// that is open, is a `missing_credential`, carries a needs form, and lands in a
// deployment holding `BLOCKER_FIX_SECRET`. Every other row is answerable in prose
// through the box below, so the absent case says that rather than reading as a
// failure.
//
// WHAT THE LINK IS, stated because the reader is being asked to type a secret
// into something a machine sent them: a signed, WRITE-ONLY capability over ONE
// blocker's field set (`value-objects/blocker-fix-link.ts`, v2). The form is
// partial-fill and each field is write-once; nothing reads a value back through
// it, and no agent ever sees one — which is the whole reason a `blocker list`
// may carry it while it may never carry a credential.
//
// IT IS SHORT-LIVED and the copy says so, for the `ArtifactLinkPanel` reason: a
// signed URL that has quietly expired looks identical to one that works, and a
// human standing in front of a dead form has no way to know to come back here.
//
// RENDERED, NOT AUTO-OPENED — a real anchor, `noopener` + `noreferrer` so the
// form's tab cannot reach back through `window.opener` and the API host is not
// handed the dashboard URL the reader came from.

export function BlockerFixLink(props: { readonly url: string | null }): JSX.Element {
  return (
    <Show when={props.url} fallback={<p class="card__desc">{t('blockers.fix_link_absent')}</p>}>
      {(url) => (
        <div class="alert" role="note">
          <p class="alert__title">{t('blockers.fix_link_title')}</p>
          <p class="alert__desc">{t('blockers.fix_link_desc')}</p>
          <a
            class={`${buttonClass({ variant: 'outline', size: 'sm' })} blocker-alert__action`}
            href={url()}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('blockers.fix_link_open')}
          </a>
        </div>
      )}
    </Show>
  );
}
